import React from "react";
import styles from "../property-features/property-features.module.scss";
import { PropertyDocumentsProps } from "./property-documents.interface";
import SkeletonC from "../../common/skeleton";
import FeaturesTag from "../../common/features-tag";
import { DocumentViewed } from "../../investor/amplitude";
import useContextHook from "../../../hooks/context/useContext";
import { useSearchParams } from "react-router-dom";

const PropertyDocuments = ({
  title,
  type,
  objPropertyDetails,
  loading,
  shareId
}: PropertyDocumentsProps) => {
  const { mobileNumber } = useContextHook();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  function getLabel(label: string) {
    let newLabel = "";
    if (label === "realistic_report") {
      newLabel = "Get Realist Report";
    } else if (label === "inspection_report") {
      newLabel = "Inspection";
    } else if (label === "comparables_report") {
      newLabel = "View Comparables";
    } else if (label === "disclosures_report") {
      newLabel = "Disclosures";
    }
    return newLabel;
  }

  function getIcon(label: string) {
    let iconUrl = "";
    if (label === "realistic_report") {
      iconUrl = "/images/disclosures.svg";
    } else if (label === "inspection_report") {
      iconUrl = "/images/note.svg";
    } else if (label === "comparables_report") {
      iconUrl = "/images/note.svg";
    } else if (label === "disclosures_report") {
      iconUrl = "/images/disclosures.svg";
    }
    return iconUrl;
  }

  const documentArray: any[] = [];
  objPropertyDetails.docs.forEach(
    (element: { url: string; type: string }, index: number) => {
      documentArray.push({
        id: index,
        label: getLabel(element?.type),
        icon: getIcon(element?.type),
        url: element.url
      });
    }
  );

  const openInNewTab = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.propertyFeatures} tabIndex={16}>
      {loading ? (
        <SkeletonC width="50%" height="30px" className="mb-3" />
      ) : (
        <div className={styles.title} tabIndex={17}>
          {title}
        </div>
      )}

      <div className={styles.featuresWrap}>
        {documentArray?.map((feat: any, index: number) => {
          return (
            <React.Fragment key={index}>
              {loading ? (
                <SkeletonC
                  width="18%"
                  height="45px"
                  className={styles.skeleton}
                />
              ) : (
                <div
                  className={styles.docOpt}
                  onClick={() => {
                    openInNewTab(feat.url);
                    if (type === "investor") {
                      DocumentViewed({
                        DocumentUrl: feat.url,
                        DocumentName: feat.label,
                        propertyId: objPropertyDetails?.propertyId,
                        opportunitySFID: objPropertyDetails?.opportunitySFID,
                        pubPropertySFID: objPropertyDetails?.pubPropertySFID,
                        propertySFID: objPropertyDetails?.propertySFID,
                        shareId: shareId || "",
                        linkCId: cid,
                        linkEmailId: eq,
                        mobileNumber: mobileNumber
                      });
                    }
                  }}
                >
                  {/* {(feat.num || feat.url) && ( */}
                  {feat.url && (
                    <FeaturesTag
                      value={feat.num}
                      label={feat.label}
                      images={feat.icon}
                      url={feat.url}
                    />
                  )}
                  {/* )} */}
                </div>
              )}
            </React.Fragment>
          );
        })}
        {/* {featuresArray.baths&&<FeaturesTag
                    value={featuresArray.baths}
                    label={'Bathrooms'}
                    images={''}
                />} */}
        {/* {loading ? (
          <SkeletonC width='15%' height='45px' className='mb-2 mr-2' />
        ) : (
          <Buttonc
            type='button'
            btnType='link'
            label={showMore ? 'See Less' : 'See All'}
              onClick={showFeature}
            className={styles.link}
            tabIndex={25}
          />
        )} */}
      </div>
    </div>
  );
};

export default React.memo(PropertyDocuments);
